import { useRef, useState } from "react";
import { type Employment, Employments } from "@components/quick_apply/employments.tsx";
import { validateEmployments, type EmploymentErrors } from "@components/quick_apply/util.ts";
import ModalFooter from "./modal_footer.tsx";
import useSectionSave from "./use_section_save.ts";
import type { SectionProps } from "./types.ts";

const seedEmployments = (data: SectionProps["data"]): Employment[] =>
  (data.employments.length > 0 ? data.employments : [{} as Employment]).map((employment) => ({
    ...employment,
    key: crypto.randomUUID().toString(),
  }));

const EmploymentSection = ({ data, onClose }: SectionProps) => {
  const { save, saving } = useSectionSave();
  const [employments, setEmployments] = useState<Employment[]>(() => seedEmployments(data));
  const [errors, setErrors] = useState<EmploymentErrors>({});
  const employmentRefs = useRef<HTMLElement[]>([]);

  const handleSave = async () => {
    const validationErrors = validateEmployments(employments);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const formData = new FormData();
    formData.append("employments", JSON.stringify(employments));

    if (await save(formData)) onClose();
  };

  return (
    <>
      <Employments
        employments={employments}
        errors={errors}
        setEmployments={setEmployments}
        employmentRefs={employmentRefs}
      />
      <ModalFooter section="employment" onSave={handleSave} onCancel={onClose} saving={saving} />
    </>
  );
};

export default EmploymentSection;
